export default __webpack_public_path__ + "static/registered-charity-fde9b64ee79ac07323e7c56c4ad2a8ad.png";